import { z } from 'zod';

import { zGoDate } from '../helpers/fix-go-types';

export const EXCEPTION_ACTIONS = [
  'discount',
  'delete',
  'drawer_open',
  'void',
  'below_cost',
  'refund',
  'edit',
  'return',
] as const;

export const ACTION_LABELS: Record<string, string> = {
  discount: 'Discount',
  delete: 'Delete',
  drawer_open: 'Drawer Open',
  void: 'Void',
  below_cost: 'Below Cost',
  refund: 'Refund',
  edit: 'Edit',
  return: 'Deposit Return',
};

export const ExceptionLogSchema = z.object({
  timestamp: zGoDate,
  close_num: z.string(),
  initials: z.string(),
  code_num: z.string(),
  brand: z.string(),
  old_price: z.number(),
  new_price: z.number(),
  quantity: z.number(),
  action: z.string(),
  barcode: z.string(),
  station: z.string(),
  invoice_number: z.number(),
});

export type ExceptionLog = z.infer<typeof ExceptionLogSchema>;
